import React from 'react';
import Select from 'react-select';

class MetaDataSelection extends React.Component {
  constructor(props) {
    super(props);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    // Note : it may change the metakeys if the post type change
    if (REBUILDER.hasOwnProperty(this.metakey)) {
      this.helperData = REBUILDER[this.metakey].helperData ? REBUILDER[this.metakey].helperData : {};
    } else {
      alert('sorry select a post type into content section');
    }
    this.metakeys = [];
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(val) {
    this.props.onMetakeySelection(val);
  }
  render() {
    this.metakeys = [];
    if (this.props.date) {
      this.metakeys.push({
        'value': 'post_date',
        'label': 'post_date',
      });
    }
    if ('metakeys' in this.helperData) {
      this.helperData.metakeys.forEach((metakey) => {
        this.metakeys.push({
          'value': metakey,
          'label': metakey,
        });
      });
    }
    return (<div className="flex-row">
      {this.metakeys.length ? <div className="flex-sm-6 flex-md-6 flex-xs-12">
        <Select
          name="form-field-name"
          placeholder="Please select a metakey"
          value={this.props.value}
          options={this.metakeys}
          onChange={this.handleChange}
        />
      </div> : <div> sorry, Please select a post type form content section </div> }
    </div>);
  }
}

MetaDataSelection.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'value': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'onMetakeySelection': React.PropTypes.func,
};


export default MetaDataSelection;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/helper/metadataSelection.js
 **/